import { EnumOption } from "./enum-option"

export const EntityType = {
    Matter: 0,
    ForeignNational: 1,
    Company: 2,
    CompanyContact: 3,
    Report: 4,
    WorkflowStep: 5,
    Task: 6,
    Questionnaire: 7,
    Form: 8,
    ProcessModule: 9,
    CompanyLocation: 10,
}

export const EntityTypeList: EnumOption[] = [
    { value: EntityType.Matter, label: 'Matter' },
    { value: EntityType.ForeignNational, label: 'Foreign National' },
    { value: EntityType.Company, label: 'Company' },
    { value: EntityType.CompanyContact, label: 'Company Contact' },
    { value: EntityType.Report, label: 'Report' },
    { value: EntityType.WorkflowStep, label: 'Workflow Step' },
    { value: EntityType.Task, label: 'Task' },
    { value: EntityType.Questionnaire, label: 'Questionnaire' },
    { value: EntityType.Form, label: 'Form' },
    { value: EntityType.ProcessModule, label: 'Process Module' },
    { value: EntityType.CompanyLocation, label: 'Company Location' },
]
